export default __webpack_public_path__ + "static/media/8W3A2099_tn.8e0e9968.jpg";